export default {
  'managerialInvoicing.label.reportType': 'Select report type',

  'managerialInvoicing.option.realXFiscal': 'Real x Fiscal',
  'managerialInvoicing.option.realXTicket': 'Real x Ticket x Average Ticket',
  'managerialInvoicing.option.avgTicket': 'Average Ticket (Parts x Services)',
  'managerialInvoicing.option.realXpayment': 'Real x Payment x Receipts',
};
